import React from "react"
import PanelLayoutContent from "components/layout/PanelLayoutContent"
import Dashboard from "views/Admin/TslNewsletter/Dashboard"
import TslNewsletterNav from "views/Admin/TslNewsletter/TslNewsletterNav"

const TslNewsletterDashboard = () => {
  return (
    <PanelLayoutContent
      title="TSL Newsletter"
      text="Pulpit administracyjny newslettera TSL"
    >
      <TslNewsletterNav />
      <Dashboard />
    </PanelLayoutContent>
  )
}

export default TslNewsletterDashboard
